import React from 'react';
import './FinalBookingView.css';
import { format, parseISO } from 'date-fns';

const FinalBookingView = ({ selectedRoom, onDone, checkinDate, checkoutDate, guests, property }) => {
  if (!selectedRoom) {
    return null;
  }

  const { room, rate: selectedRate } = selectedRoom;
  const { name, carousel } = room;
  const { total_after_tax } = selectedRate;
  const image = carousel && carousel.length > 0 ? carousel[0] : '';

  const formatDate = (dateString) => {
    if (!dateString) return '';
    return format(parseISO(dateString), 'MMM dd, yyyy');
  };

  const formatGuests = () => {
    if (!guests) return 'N/A';
    const { adults, children } = guests;
    const totalGuests = adults + children;
    if (totalGuests === 0) return 'N/A';
    if (totalGuests === 1) return '1 adult';
    return `${totalGuests} guests`;
  };

  return (
    <div className="final-booking-view">
      <div className="success-icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="green">
          <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
        </svg>
      </div>
      <h2>Booking Confirmed!</h2>
      <p>Your booking at <strong>{property.name}</strong> has been successfully confirmed.</p>
      <div className="booking-summary">
        <img src={image} alt={name} className="final-booking-room-image" />
        <div className="room-info">
          <h3>{name}</h3>
          <div className="final-booking-details">
            <p><strong>Check-in:</strong> {formatDate(checkinDate)}</p>
            <p><strong>Check-out:</strong> {formatDate(checkoutDate)}</p>
            <p><strong>Guests:</strong> {formatGuests()}</p>
            <p className="price">Total Paid: ${total_after_tax}</p>
          </div>
        </div>
      </div>
      <p className="simulation-notice">(This is a simulation. No real booking has been made.)</p>
      <button className="done-button" onClick={onDone}>
        Done
      </button>
    </div>
  );
};

export default FinalBookingView; 